module.exports = __webpack_public_path__ + "static/img/アセット 12@2x.5c00313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/アセット 12@2x.png
// module id = 7rNc
// module chunks = 1